import axios from 'axios';

import { API_BASE_URL } from '../config';

const BASE_URL = API_BASE_URL;


const instance = axios.create({
    baseURL: BASE_URL,
    // withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

export const authenticateWithOdoo = async (data) => {
    console.log('🔄 Login request data:', data);

    // The API expects /login endpoint, not /api/login
    // Our proxy will forward /api/login to https://api.goexia.com/api/login
    const url = data.token ? `/login-with-token` : `/login`;
    try {
        console.log('📍 Making request to:', url);
        console.log('🌐 This will be proxied to:' + BASE_URL + url);
        const response = await instance.post(url, data, {});
        console.log('✅ Login response:', response.status, response.statusText);
        return response.data;
    } catch (error) {
        console.error('❌ Login error details:', {
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            url: error.config?.url,
            method: error.config?.method,
            fullUrl: BASE_URL + url
        });
        console.error('💥 Full error:', error.response?.data || error.message);
        throw error;
    }
};

export const registerWithOdoo = async (data) => {
    console.log('registerWithOdoo data:', data);
  
    try {
      const response = await axios.post(`${BASE_URL}/register`, data);
      console.log('response:', response);
  
      // Standardize success response
      return {
        success: true,
        data: response, // Include the response data
        message: 'Registration successful', // Add a custom success message if needed
      };
    } catch (err) {
      console.error('Error in registerWithOdoo:', err);
  
      // Extract status and error message
      const status = err.response?.status || 500; // Default to 500 if no status is available
      console.log(err.response);
      const errorMessage =
        err.response?.data?.message || // Error message from the backend
        (status === 400
          ? 'Bad Request: Invalid input'
          : status === 401
          ? 'Unauthorized: Please log in'
          : status === 500
          ? 'Server Error: Please try again later'
          : 'An unknown error occurred'); // Fallback message
  
      // Standardize error response
      return {
        success: false,
        status, // Include HTTP status code
        message: errorMessage, // Provide a detailed error message
      };
    }
  };
  